module.exports = __webpack_public_path__ + "static/assets/08ba07fa52ec0ae98119cf0cf912f5ef.svg";